<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table
          :headers="headersCondominio"
          :items="condominio"
          :search="searchCondominio"
          sort-by="name"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title"
                >Simulador Produtor - Condomínio</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-text-field
                v-model="searchCondominio"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>

              <v-btn
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(condominio, 'condominio')"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.contactado == '0'"
              x-small
              depressed
              class="mr-2"
              fab
              dark
              color="#90A99C"
              @click="contactado(item)"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              v-else
              x-small
              depressed
              class="mr-2"
              fab
              dark
              color="#90A99C"
              @click="reverterContactado(item)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
      <template>
        <div class="text-center">
          <v-snackbar v-model="snackbar">
            Lead atualizada com sucesso!
          </v-snackbar>
        </div>
      </template>
    </v-card>

    <v-card class="table-container mt-5">
      <template>
        <v-data-table
          :headers="headersCondominio"
          :items="empresa"
          :search="searchEmpresa"
          sort-by="name"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title"
                >Simulador Produtor - Empresa/Outro</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-text-field
                v-model="searchEmpresa"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>

              <v-btn
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(empresa, 'Empresa-Outro')"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.contactado == '0'"
              x-small
              depressed
              class="mr-2"
              fab
              dark
              color="#90A99C"
              @click="contactado(item)"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              v-else
              x-small
              depressed
              class="mr-2"
              fab
              dark
              color="#90A99C"
              @click="reverterContactado(item)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
      <template>
        <div class="text-center">
          <v-snackbar v-model="snackbar">
            Lead atualizada com sucesso!
          </v-snackbar>
        </div>
      </template>
    </v-card>

    <v-card class="table-container mt-5">
      <template>
        <v-data-table
          :headers="headersIndividual"
          :items="individual"
          :search="search"
          sort-by="name"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title"
                >Simulador Individual</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>

              <v-btn
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(individual, 'Consumidor')"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.contactado == '0'"
              x-small
              depressed
              class="mr-2"
              fab
              dark
              color="#90A99C"
              @click="contactado(item)"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              v-else
              x-small
              depressed
              class="mr-2"
              fab
              dark
              color="#90A99C"
              @click="reverterContactado(item)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
      <template>
        <div class="text-center">
          <v-snackbar v-model="snackbar">
            Lead atualizada com sucesso!
          </v-snackbar>
        </div>
      </template>
    </v-card>
  </section>
</template>

<script>
  import { json2excel } from "js2excel";
  // import Papa from "papaparse";

  export default {
    name: "pages",
    data: () => ({
      search: "",
      searchCondominio: "",
      searchEmpresa: "",
      dialog: false,
      headersIndividual: [
        { text: "ID", align: "start", sortable: true, value: "id" },
        { text: "Data da Simulação", value: "data" },
        { text: "Nome", value: "nome", width: "200px" },
        { text: "Apelido", sortable: true, value: "apelido", width: "200px" },
        { text: "Email", sortable: true, value: "email", width: "200px" },
        { text: "Telefone", sortable: true, value: "telefone", width: "200px" },
        {
          text: "Localidade",
          sortable: true,
          value: "localidade",
          width: "200px",
        },
        {
          text: "Código Postal",
          sortable: true,
          value: "codigo_postal",
          width: "150px",
        },
        { text: "NIF", sortable: true, value: "nif", width: "150px" },
        {
          text: "Valor Mês",
          sortable: true,
          value: "valor_pago",
        },
        {
          text: "Tipologia de Cliente",
          sortable: true,
          value: "tipo_cliente",
        },
      ],
      headersCondominio: [
        { text: "ID", align: "start", sortable: true, value: "id" },
        { text: "Data da Simulação", value: "data" },
        { text: "Nome", value: "nome", width: "200px" },
        { text: "Apelido", sortable: true, value: "apelido", width: "200px" },
        { text: "Email", sortable: true, value: "email", width: "200px" },
        { text: "Telefone", sortable: true, value: "telefone", width: "200px" },
        {
          text: "Localidade",
          sortable: true,
          value: "localidade",
          width: "200px",
        },
        {
          text: "Código Postal",
          sortable: true,
          value: "codigo_postal",
          width: "150px",
        },
        { text: "NIF", sortable: true, value: "nif", width: "150px" },
        {
          text: "Valor Mês",
          sortable: true,
          value: "valor_pago",
        },
        {
          text: "Tipologia de Cliente",
          sortable: true,
          value: "tipo_cliente",
        },
        {
          text: "Tipologia Espaço",
          sortable: true,
          value: "tipo_espaco",
          width: "150px",
        },
        {
          text: "Área Útil",
          sortable: true,
          value: "area_util",
          width: "150px",
        },
        {
          text: "Tipologia Telhado",
          sortable: true,
          value: "tipo_Telhado",
          width: "150px",
        },
        {
          text: "Tipologia Terreno",
          sortable: true,
          value: "tipo_Terreno",
          width: "150px",
        },
        {
          text: "Potencia por painel",
          sortable: true,
          value: "potencia_Painel",
          width: "150px",
        },
        {
          text: "Produção Anual Autoconsumo",
          sortable: true,
          value: "producao_Anual_Auto_Consumo",
          width: "150px",
        },
        {
          text: "Produção Anual Energia Partilhada",
          sortable: true,
          value: "producao_anual_Energia_Partilhada",
          width: "150px",
        },
        {
          text: "Contactado",
          sortable: true,
          value: "contactado",
        },
        { text: "Acções", value: "actions", align: "end", sortable: false },
      ],
      snackbar: false,
      condominio: [],
      empresa: [],
      individual: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      estado: "",
      productMsg: "",
      createResult: {},
      updateResult: {},
      final: {},

      image: [],
      image_2: [],
      image_3: [],
      video: [],
      form_data: new FormData(),

      link_1: [],
      link_2: [],
      link_3: [],
      link_4: [],
      link_5: [],
    }),

    async mounted() {
      await this.initialize();
    },

    methods: {
      export_excel: async function(data, nomeFicheiro) {
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          if (data[i].area_util) {
            data[i].area_util = Number(data[i].area_util);
          }
        }
        try {
          json2excel({
            data,
            name: "Export_Simulação-" + nomeFicheiro,
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("export error");
        }
      },
      export_excel_teste: async function(data) {
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].area_util = Number(data[i].area_util);
        }
        console.log(data);
      },
      async initialize() {
        let res = await this.$store.dispatch("collectPages", this);

        var leads = Object.values(res);
        var condominio = [];
        let empresa = [];
        let individual = [];

        for (let i = 0; i < leads.length; i++) {
          var json = JSON.parse(leads[i].resultados);
          if (leads[i].tipo_cliente == "Condomínio") {
            if (json.Simulacao.cliente) {
              leads[i].tipEspaco = json.Simulacao.cliente.tipologia;
              leads[i].area_util =
                Number(json.Simulacao.cliente.area_telhado) +
                Number(json.Simulacao.cliente.area_terreno);

              leads[i].tipTelhado = json.Simulacao.cliente.tipo_telhado;
              leads[i].tipTerreno = json.Simulacao.cliente.tipo_terreno;
            } else {
              leads[i].area_util = Number(json.resultados.areaUtil).toFixed(2);
            }
            leads[i].potPainel = json.resultados.potenciaPorPainelkW;
            leads[i].producaoAnualAC =
              json.resultados.producaoAnualEnergiaPartilhada;
            leads[i].producaoAnualEP = json.resultados.energiaParaPartilhar;

            condominio.push({
              id: leads[i].id,
              data: leads[i].data,
              nome: leads[i].nome,
              apelido: leads[i].apelido,
              email: leads[i].email,
              telefone: leads[i].telefone,
              localidade: leads[i].localidade,
              codigo_postal: leads[i].cod_postal,
              nif: leads[i].nif,
              valor_pago: leads[i].valor_pago,
              tipo_cliente: leads[i].tipo_cliente,
              tipo_espaco: leads[i].tipEspaco,
              area_util: leads[i].area_util,
              tipo_Telhado: leads[i].tipTelhado,
              tipo_Terreno: leads[i].tipTerreno,
              potencia_Painel: leads[i].potPainel,
              producao_Anual_Auto_Consumo: leads[i].producaoAnualAC,
              producao_anual_Energia_Partilhada: leads[i].producaoAnualEP,
              contactado: leads[i].contactado,
            });
          } else if (leads[i].tipo != "consumidor") {
            if (json.Simulacao.cliente) {
              leads[i].tipEspaco = json.Simulacao.cliente.tipologia;
              leads[i].area_util =
                Number(json.Simulacao.cliente.area_telhado) +
                Number(json.Simulacao.cliente.area_terreno);
              leads[i].tipTelhado = json.Simulacao.cliente.tipo_telhado;
              leads[i].tipTerreno = json.Simulacao.cliente.tipo_terreno;
            } else {
              leads[i].area_util = Number(json.resultados.areaUtil).toFixed(2);
            }
            leads[i].potPainel = json.resultados.potencia_Por_PainelkW;
            leads[i].producaoAnualAC =
              json.resultados.producaoAnualEnergiaPartilhada;
            leads[i].producaoAnualEP = json.resultados.producaoAutoConsumo;
            empresa.push({
              id: leads[i].id, //BOM
              data: leads[i].data, //BOM
              nome: leads[i].nome, //BOM
              apelido: leads[i].apelido, //BOM
              email: leads[i].email, //BOM
              telefone: leads[i].telefone, //BOM
              localidade: leads[i].localidade, //BOM
              codigo_postal: leads[i].cod_postal, //BOM
              nif: leads[i].nif, //BOM
              valor_pago: leads[i].valor_pago, //BOM
              tipo_cliente: leads[i].tipo_cliente, //BOM
              tipo_espaco: leads[i].tipEspaco, //BOM
              area_util: leads[i].area_util, //BOM
              tipo_Telhado: leads[i].tipTelhado, //BOM
              tipo_Terreno: leads[i].tipTerreno, //BOM
              potencia_Painel: leads[i].potPainel, //BOM
              producao_Anual_Auto_Consumo: leads[i].producaoAnualAC
                ? leads[i].producaoAnualAC.toFixed(2)
                : leads[i].producaoAnualAC, //BOM
              producao_anual_Energia_Partilhada: leads[i].producaoAnualEP
                ? leads[i].producaoAnualEP.toFixed(2)
                : leads[i].producaoAnualEP, //BOM
              contactado: leads[i].contactado, //BOM
            });
          } else {
            individual.push({
              id: leads[i].id,
              data: leads[i].data,
              nome: leads[i].nome,
              apelido: leads[i].apelido,
              email: leads[i].email,
              telefone: leads[i].telefone,
              localidade: leads[i].localidade,
              codigo_postal: leads[i].cod_postal,
              nif: leads[i].nif,
              valor_pago: leads[i].valor_pago,
              tipo_cliente: leads[i].tipo_cliente,
              contactado: leads[i].contactado,
            });
          }
        }
        this.condominio = condominio;
        this.empresa = empresa;
        this.individual = individual;
      },
      async contactado(item) {
        var data = {
          id: item.id,
        };
        await this.$store.dispatch("contactadoSimuladores", data);
        this.snackbar = true;
        this.initialize();
      },
      async reverterContactado(item) {
        var data = {
          id: item.id,
        };
        await this.$store.dispatch("contactadoSimuladoresReverter", data);
        this.snackbar = true;
        this.initialize();
      },
    },
  };
</script>
